import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import {useSoftwareIndicatorEvaluationPeriods} from './useSoftwareIndicatorEvaluationPeriods'

export default function SoftwareIndicatorYearDropdown({selectedYear, disabledOptions, setYear}: { selectedYear: string | undefined, disabledOptions?: string[], setYear: (year: string) => void }) {
  const {evaluationPeriods} = useSoftwareIndicatorEvaluationPeriods()


  return (
    <div>
      <Box minWidth={120}>
        <FormControl fullWidth>
          <InputLabel id="year-label">Evaluation Year</InputLabel>
          <Select
            labelId="year-label"
            id="year-select"
            value={selectedYear}
            onChange={(ev) => (setYear(ev.target.value))}
            label="Evaluation Year"
          >
            {evaluationPeriods.map(year => {
              return <MenuItem key={year} value={year} disabled={disabledOptions?.includes(year)}>{year}</MenuItem>
            })}
          </Select>
        </FormControl>
      </Box>
    </div>
  )
}
